import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const STATUS_OPTIONS = [
  {
    label: 'پرداخت نشده',
    value: 'پرداخت نشده',
  },
  {
    label: 'لغو شده قبل از پرداخت',
    value: 'لغو شده قبل از پرداخت',
  },
  {
    label: 'پرداخت شده',
    value: 'پرداخت شده',
  },
  {
    label: 'بسته شده',
    value: 'بسته شده',
  },
  {
    label: 'مسترد شده',
    value: 'مسترد شده',
  },
];
const PAYMENT_TYPES = [
  {
    label: 'پرداخت با کارت در cms',
    value: 'پرداخت با کارت در cms',
  },
  {
    label: 'اعتبار',
    value: 'اعتبار',
  },
  {
    label: 'پرداخت در شعبه',
    value: 'پرداخت در شعبه',
  },
  {
    label: 'پیامک با اعتبار',
    value: 'پیامک با اعتبار',
  },
  {
    label: 'برداشت از سپرده توسط انتقال وجه',
    value: 'برداشت از سپرده توسط انتقال وجه',
  },
  {
    label: 'پرداخت با پایا',
    value: 'پرداخت با پایا',
  },

  {
    label: 'پرداخت از طریق مراجعه به بانک',
    value: 'پرداخت از طریق مراجعه به بانک',
  },
  {
    label: 'درگاه پاسارگاد',
    value: 'درگاه پاسارگاد',
  },
  {
    label: 'پرداخت با ترمینال (پوز)',
    value: 'پرداخت با ترمینال (پوز)',
  },
  {
    label: 'پرداخت در سیستم',
    value: 'پرداخت در سیستم',
  },
  {
    label: 'پرداخت با درگاه اقساطی',
    value: 'پرداخت با درگاه اقساطی',
  },
  {
    label: 'مستقیم',
    value: 'مستقیم',
  },
  {
    label: 'چک',
    value: 'چک',
  },
  {
    label: 'پرداخت با سپرده بانکی',
    value: 'پرداخت با سپرده بانکی',
  },
  {
    label: 'برداشت وجه مستقیم پاسارگاد',
    value: 'برداشت وجه مستقیم پاسارگاد',
  },
];

const filters = (guildOptions = [] , currencyText) => [
  {
    title: 'محدوده تاریخ صدور',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {
        minDate: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(366, 'days'),
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      end: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
    },
    disableDelete: true,
  },
  {
    title: 'شناسه فاکتور',
    label: 'شناسه فاکتور',
    keyName: 'invoiceId',
    id: 1356,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'شناسه ارجاع',
    label: 'شناسه ارجاع',
    keyName: 'refrenceId',
    id: 1360,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'محدوده‌ مبلغ قابل پرداخت',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'amountPayable',
    id: {
      start: 1357,
      end: 1358,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'محدوده تاریخ پرداخت',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateOfPayment',
    id: {
      start: 1452,
      end: 1453,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {
        minDate: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(366, 'days'),
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      end: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
    },
  },
  {
    title: 'براساس وضعیت فاکتور',
    label: 'وضعیت فاکتور',
    keyName: 'status',
    id: 1359,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_OPTIONS,
    },
  },
  {
    title: 'جستجوی نام کسب‌وکار',
    label: 'نام کسب‌وکار',
    keyName: 'businessName',
    id: 1361,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'براساس نوع پرداخت',
    label: 'نوع پرداخت',
    keyName: 'paymentType',
    id: 1362,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: PAYMENT_TYPES,
    },
  },
];

export default filters;
